import MicrosoftIcon from 'flow/components/icons/MicrosoftIcon';
import GoogleIcon from 'flow/components/icons/GoogleIcon';
import isElectron from 'is-electron';
import { electronActions } from 'flow/utils/electron-utils';
import { history } from 'flow/configure-store';
import {
    fetchSocialIntegrationSettings,
    externalSyncIsDone,
} from 'flow/actions/social-integration-actions';
import { generatePath } from 'flow/utils/router-utils';
import { electronListeners } from 'flow/utils/electron-utils';
import { setPreventUnload } from 'flow/actions/app-actions';
import { getBrand } from 'flow/brands/brands';
import { routes } from 'flow/types/routes';

export const getSocialIntegrationUrlElectron = () => {
    const brandAppUrl = getBrand().brandAppUrl;
    if (!brandAppUrl) {
        return null; // Return null if no app URL is available
    }
    return `${brandAppUrl}/socialintegration/oauthlanding`;
};

export const MSGOO_APP_REG_DEFAULT_VALUE = null;

export const getIcon = (syncSource, size) => {
    if (syncSource === 'google') {
        return <GoogleIcon size={size} />;
    } else if (syncSource === 'microsoft') {
        return <MicrosoftIcon size={size} />;
    } else {
        return null;
    }
};

export const getSyncSourceName = (syncSource, i18next) => {
    if (syncSource === 'google') {
        return i18next.t('settings.social_integration.google');
    } else if (syncSource === 'microsoft') {
        return i18next.t('settings.social_integration.microsoft');
    } else {
        return null;
    }
};

export const getNbrSyncedContactsDescription = (nbrSyncedContacts, i18next) => {
    if (nbrSyncedContacts === 1) {
        return i18next.t('settings.social_integration.one_contact');
    } else {
        return i18next.t('settings.social_integration.nbr_contacts', {
            nbr: nbrSyncedContacts,
        });
    }
};

export const hasCalendarSync = (socialIntegrationSettings) => {
    return (
        hasSync(socialIntegrationSettings, 'google', 'calendar') ||
        hasSync(socialIntegrationSettings, 'microsoft', 'calendar')
    );
};

const hasSync = (socialIntegrationSettings, syncSource, syncType) => {
    return (
        socialIntegrationSettings.has(syncSource) &&
        socialIntegrationSettings.getIn([syncSource, 'syncTypes']) &&
        socialIntegrationSettings
            .getIn([syncSource, 'syncTypes'])
            .includes(syncType)
    );
};

export const synchronisationEnabled = (syncTypes) => {
    return (
        syncTypes &&
        (syncTypes.includes('contacts') || syncTypes.includes('calendar'))
    );
};

export const createReturnUrl = (extensionKey, syncSource) => {
    const redirectPath = `/settings/${extensionKey}/account/socialintegration/callback/${syncSource}`;
    const webUrl = window.location.origin + redirectPath;

    return isElectron() ? getSocialIntegrationUrlElectron() : webUrl;
};

export const goToExternalSignIn = async (
    dispatch,
    signInUrl,
    syncSource,
    extensionKey,
) => {
    if (isElectron()) {
        electronListeners.checkIfSocialIntegrationSignInFinished(
            dispatch,
            extensionKey,
            syncSource,
        );
        electronActions.socialIntegrationSignIn(signInUrl);
    } else {
        setPreventUnload(true);
        window.open(signInUrl, '_blank', 'height=800,width=600');
        const messageEventListener = async (event) => {
            if (
                event.data.direction &&
                event.data.direction === 'social-integration-callback'
            ) {
                if (event.data.message === 'done') {
                    await dispatch(fetchSocialIntegrationSettings());
                    history.push(
                        generatePath(
                            routes[
                                'settings.account.socialintegration.integration'
                            ],
                            {
                                extensionKey,
                                syncSource,
                            },
                        ),
                    );
                } else if (event.data.message === 'fail') {
                    await dispatch(fetchSocialIntegrationSettings());
                    history.push(
                        generatePath(routes['settings.account'], {
                            extensionKey,
                        }),
                    );
                }
                dispatch(externalSyncIsDone(true));
                window.removeEventListener('message', messageEventListener);
            }
        };
        window.addEventListener('message', messageEventListener);
    }
};
